"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFindDeliveryStore = void 0;

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var _reactQuery = require("react-query");

var _types = require("../types");

var _api = require("../api");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var useFindDeliveryStore = function useFindDeliveryStore() {
  return (0, _reactQuery.useMutation)(function (req) {
    return (0, _api.fetchFindDeliveryStore)(req);
  }, {
    onError: function onError(error) {
      var _a;

      var _b = ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) || {},
          text = _b.text,
          code = _b.code;

      Sentry.getCurrentHub().withScope(function (scope) {
        scope.setExtras({
          exceptionMessage: text,
          exceptionCode: code,
          hook: 'useFindDeliveryStore'
        });
        scope.setTags({
          "package": 'api/store',
          api: _types.Endpoints.FindDeliveryStore
        });
        Sentry.getCurrentHub().captureException(new Error(text));
      });
    }
  });
};

exports.useFindDeliveryStore = useFindDeliveryStore;